import { render, staticRenderFns } from "./editCheckType.vue?vue&type=template&id=705d30b7&scoped=true&"
import script from "./editCheckType.vue?vue&type=script&lang=js&"
export * from "./editCheckType.vue?vue&type=script&lang=js&"
import style0 from "./editCheckType.vue?vue&type=style&index=0&id=705d30b7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705d30b7",
  null
  
)

export default component.exports